export class ConsentAnswer {
  consentId: number;
  text: string;
  order: number;
}
